import type { CatalogCarouselItem } from '~/features/experiments/ab_plp_redesign_2025/models/catalog-carousel-item';
import { getDefaultCatalogCarouselItems } from '~/features/experiments/ab_plp_redesign_2025/utils/get-default-catalog-carousel-items';
import type { useI18n } from '~/hooks/use-i18n';

import type { ClaudeEngineerVariant } from '../models/variant';

import { getCatalogClaudeEngineerCarouselItem } from './get-catalog-claude-engineer-carousel-item';

type TranslateFn = ReturnType<typeof useI18n>['t'];

export function getClaudeEngineerCatalogCarouselItems(
  t: TranslateFn,
  variant: ClaudeEngineerVariant
): CatalogCarouselItem[] {
  return [
    getCatalogClaudeEngineerCarouselItem(variant),
    ...getDefaultCatalogCarouselItems(t, { omitAgenticAiNanodegree: true }),
  ];
}
